import { Component,ViewChild, OnInit, ElementRef, AfterViewChecked } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';
import { FinanceService } from 'src/app/services/Finance/finance.service';
import { HttpClient } from '@angular/common/http';
import { WindowRefService } from 'src/app/services/Common/window-ref.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-student-fee-payment',
  templateUrl: './student-fee-payment.component.html',
  styleUrls: ['./student-fee-payment.component.css']
})
export class StudentFeePaymentComponent implements AfterViewChecked {
posting = false;

public feePaymentForm = new FormGroup({
    FeeList: new FormControl(''),
    BasicDetails: new FormControl(''),
});

 @ViewChild('myFormFeePayment',{static:false}) myFormFeePayment: ElementRef;
  constructor(private router: Router,private winRef: WindowRefService, private http:HttpClient,private financeService:FinanceService,private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }

  Submitted = false;
  PaymentReceiptList:any;
  TotalPaidAmounts=0;
  TotalFineAmounts=0;
  
  GetPaymentReceipt  () {
    
    this.Submitted = true;
    if (true) {
      this.spinnerService.show();
 this.studentPortalService.GetPaymentReceipt(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
  this.spinnerService.hide();
  this.PaymentReceiptList = response.PaymentReceiptList;
            this.Submitted = false;            
            var TotalPaidAmounts = 0;
            var TotalFineAmounts = 0;
            for (var i = 0; i < this.PaymentReceiptList.length; i++) {
                TotalPaidAmounts = TotalPaidAmounts + this.PaymentReceiptList[i].PaidAmount;
                TotalFineAmounts = TotalFineAmounts + this.PaymentReceiptList[i].Fine;
            }
            this.TotalPaidAmounts = TotalPaidAmounts;
            this.TotalFineAmounts = TotalFineAmounts;
            
        });
    }
}

FeeReceiptModel = {
  merchant_id:"",
  access_code:'',
  working_key:'',
  redirect_url:"",
  Salt:"",
  CreatedBy:"",
  FatherName:"",
  MotherName:'',
  PresentAddress:"",
  tid:"",
  CityName:"",
  StateName:"",
  PresentZipCode:"",
  CountryName:"",
  StudentNo:"",
  BranchID:"",
  TotalDiscountAmount:0,
  TransportAmount:0,
  DueFee:0,
  SessionID:0,
    ClassID: 0,
    StudentID: 0,
    FirstName: '',
    MiddleName: '',
    currency:'INR',
    LastName: '',
    TotalAmount:0,
    ClassName: '',
    StreamName: '',
    StudentName: '',
    PaymentMode: '',
    PaidAmount: 0,
    FeeAmount: 0,
    Fine: 0,
    PayingAmount:0,
    OpeningAmount: 0,
    WaiverAmount: 0,
    BankCharges: 0,
    BankAccountID: 0,
    StudentStatus: 0,
    EmailID: '',
    TeacherEmailID: '',
    ReferenceNo: '',
    PaymentDate: '',
    Mobile: '',
    DOB:'',
    FatherContactHome: '',
    FatherContactCell:'',
    MotherContactCell: '',
    PartialRemarks: '',
}

SearchModel = {
    StudentID: 0,
    SectionID: 0,
    CancelStatus: 'N',
    ClassID: 0,
    StudentNo: '',
    FromDate: '',
    PaymentMode: '',
    ToDate: '',
    CreatedBy: ''
}
    isCollapsed1 = true;
  GetOpeningBalance  () {
 var   itembo = {
        ItemId: this.FeeReceiptModel.StudentID,
        SessionID: this.FeeReceiptModel.SessionID
    }
    this.lookupService.GetLookupsList('OpeningBalance', JSON.stringify(itembo)).subscribe((data: any) => {
        if (data.LookupItems.length > 1) {
            this.FeeReceiptModel.Fine = 0;
            this.FeeReceiptModel.FeeAmount = 0;
            this.FeeReceiptModel.OpeningAmount = data.LookupItems[1].OpeningAmount;
            this.GetTotalPaidAmount();
        }
        else {
            this.FeeReceiptModel.OpeningAmount = 0;
        }
    });
};
ReceiptNo = '';
InstallmentComponentList =[];
InstallmentList = [];
FeeComponentList = [];
  ComponentList =[];
GetID(item) {
    this.SearchModel.StudentID = item.StudentID;          
   
    this.FeeReceiptModel = item;
    this.FeeReceiptModel.ClassID = item.ClassID;
    this.FeeReceiptModel.BranchID = this.globalHelper.GetLoginToken().BranchID.toString();
    this.FeeReceiptModel.Mobile = item.Mobile;
    this.FeeReceiptModel.FatherName = item.FatherName;
    this.FeeReceiptModel.MotherName = item.MotherName;
    this.FeeReceiptModel.FatherContactHome = item.FatherContactHome;
    this.FeeReceiptModel.FatherContactCell = item.FatherContactCell;
    this.FeeReceiptModel.MotherContactCell = item.MotherContactCell;
    this.FeeReceiptModel.DOB =item.DOB!=null && item.DOB!=''?moment(item.DOB).format('DD-MMM-YYYY'):'';
    this.FeeReceiptModel.EmailID = item.EmailID!=null && item.EmailID!=''?item.EmailID:"ashok@jdaas.com";   
    this.FeeReceiptModel.TeacherEmailID = item.TeacherEmailID;
    this.FeeReceiptModel.StudentStatus = item.StudentStatus;
    this.ReceiptNo = '';
    this.FeeReceiptModel.PayingAmount = 0;
    this.FeeReceiptModel.OpeningAmount = 0;
    this.GetPaymentReceipt();
    this.InstallmentComponentList =[];
    this.InstallmentList = [];
    this.FeeComponentList = [];
    this.ComponentList =[];
    
   
    this.GetFineRule();
   
    this.GetFeeInstallmentComponent();
    this.GetOpeningBalance();
    
    this.FeeReceiptModel.PaymentMode = "CASH";
    this.FeeReceiptModel.PaymentDate = moment(new Date(Date.now())).format('DD-MMM-YYYY');
    alert(this.globalHelper.GetLoginToken().MerchantID)
    alert(this.globalHelper.GetLoginToken().WorkingKey)
    alert(this.globalHelper.GetLoginToken().AccessCode)
    this.FeeReceiptModel.merchant_id=this.globalHelper.GetLoginToken().MerchantID;
    this.FeeReceiptModel.working_key=this.globalHelper.GetLoginToken().WorkingKey;
    this.FeeReceiptModel.access_code=this.globalHelper.GetLoginToken().AccessCode;
    this.FeeReceiptModel.redirect_url=this.globalHelper.GetLoginToken().ResponseURL,
    this.FeeReceiptModel.Salt=this.globalHelper.GetLoginToken().Salt,
    this.FeeReceiptModel.CreatedBy=this.globalHelper.GetLoginToken().LoginId
    
}

loadingSearch = false;
StudentList = [];
IsHide=false;
test={
  abc:"abc"
}

GetStudentDetails  () {
    
    this.StudentList = [];
    this.loadingSearch = true;
    this.spinnerService.show();
  
    this.studentPortalService.GetStudentDetailsForFeePayment_StudentPoratl().subscribe((data: any) => {
        this.globalHelper.CheckActionStatus(data);
        this.spinnerService.hide();
      
        if (data.webResponse.Status) {
            this.StudentList = data.StudentList;
            this.SearchModel.StudentID = data.StudentList[0].StudentID;
            this.GetID(this.StudentList[0]);

        }
    });
};
FineRuleList:any;
GetFineRule  () {
  
    var itembo = {
        SessionID: this.FeeReceiptModel.SessionID
    }
    this.lookupService.GetLookupsList('FineRule', JSON.stringify(itembo)).subscribe((data: any) => {
        this.FineRuleList = data.LookupItems;

    });
};




 dateDiff1(firstDate, secondDate) {
    firstDate = new Date(firstDate);
    secondDate = new Date(secondDate);
    if (!isNaN(firstDate) && !isNaN(secondDate)) {
        firstDate.setHours(0, 0, 0, 0); //ignore time part
        secondDate.setHours(0, 0, 0, 0); //ignore time part
        var dayDiff = secondDate - firstDate;
        dayDiff = dayDiff / 86400000; // divide by milisec in one day
        return dayDiff;
    }
}

GetDueAmount  (item, index) {
    var CurrentDate = new Date();
    var year = CurrentDate.getFullYear();
    var month = CurrentDate.getMonth() + 1;
    var day = CurrentDate.getDate();

    var fine = 0;

    for (var i = index; i >= 0; i--) {
        if (this.FeeComponentList[i].IsActive && (this.FeeComponentList[i].TotalAmount-this.FeeComponentList[i].DiscountAmount-this.FeeComponentList[i].PaidAmount)>0) {

            if (true) {
                if (this.FineRuleList[1].IsPerDay) {
                    var dayDiff = 0;
                    dayDiff = this.dateDiff1(this.FeeComponentList[i].AlertDate, CurrentDate)
                    if (dayDiff > this.FineRuleList[1].MaxFineDays) {
                        dayDiff = this.FineRuleList[1].MaxFineDays;
                    }

                    if (fine == 0 && dayDiff > 0) {

                        fine = dayDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }
                    else if (dayDiff > 0) {
                        fine = fine + dayDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }

                }
                else  if (this.FineRuleList[1].IsPerWeek) {
                  
                    var dayDiff = 0;
                    let weekDiff=0;                                                          
                    dayDiff = this.dateDiff1(this.FeeComponentList[i].AlertDate, CurrentDate)     
                    weekDiff=Math.ceil(dayDiff/7);  
                    if (weekDiff > this.FineRuleList[1].MaxFineDays) {
                        weekDiff = this.FineRuleList[1].MaxFineDays;
                    }

                    if (fine == 0 && weekDiff > 0) {
                        fine = weekDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }
                    else if (weekDiff > 0) {
                        fine = fine + weekDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }

                }
                else if (this.FineRuleList[1].IsPerMonth) {

                    var dayDiff = 0;
                    let monthDiff = 0;
                    dayDiff = this.monthDiff(new Date(this.FeeComponentList[i].DueAlertDate), new Date())
                    monthDiff = dayDiff;
                    if (monthDiff > this.FineRuleList[1].MaxFineDays) {
                        monthDiff = this.FineRuleList[1].MaxFineDays;
                    }

                    if (fine == 0 && monthDiff > 0) {
                        fine = monthDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }
                    else if (monthDiff > 0) {
                        fine = fine + monthDiff * this.FineRuleList[1].FineAmount;
                        dayDiff = 0;
                    }

                }
                else
                    if (this.FineRuleList[1].IsFixed) {
                        if (CurrentDate > new Date(this.FeeComponentList[i].AlertDate)) {

                            if (fine == 0) {
                                fine = this.FineRuleList[1].FineAmount;
                            }
                            else {
                                fine = fine + this.FineRuleList[1].FineAmount;
                            }
                        }
                    }

            }

        }


    }

    this.FeeReceiptModel.Fine = fine;
    this.GetTotalPaidAmount();
}
monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth();
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
}
 dateDiff(date) {
    var myDate1 = new Date(date);

    var today = new Date();

    var year = today.getFullYear();
    var month = today.getMonth() + 1;
    var day = today.getDate();
    var yy = moment(myDate1).format('YYYY');
    var mm = moment(myDate1).format('MM');
    var dd = moment(myDate1).format('DD');
    var years, months, days;

    months = month - parseInt(mm);
    if (day < parseInt(dd)) {
        months = months - 1;
    }
    // years
    years = year - parseInt(yy);

    if ((month) * 100 + (day) < parseInt(mm) * 100 + parseInt(dd)) {
        years = years - 1;
        months = parseInt(months) + 12;
    }
    // days
    days = Math.floor((today.getTime() - (new Date(parseInt(yy) + parseInt(years), parseInt(mm) + parseInt(months) - 1, parseInt(dd))).getTime()) / (24 * 60 * 60 * 1000));
    //
    return { years: years, months: months, days: days };
}
month:any;
ChkSelectInstallment  (item, index) {
    var myDate = new Date();
    this.month = moment(myDate).format('MMM');

    if (index <= this.FeeComponentList.length - 1) {
        var pflag = true;
        var i = index - 1;
        if (i >= 0) {
            for (i ; i >= 0; i--) {
                if (this.FeeComponentList[i].IsActive == false && (this.FeeComponentList[i].TotalAmount - this.FeeComponentList[i].DiscountAmount - this.FeeComponentList[i].PaidAmount > 0)) {
                    pflag = false;
                    break;
                }
            }
        }

        var nflag = false;
        if (index <= this.FeeComponentList.length - 1 && index != this.FeeComponentList.length - 1) {
            for (var j = index + 1; j < this.FeeComponentList.length; j++) {
                if (this.FeeComponentList[j].IsActive)
                    break;

                if (this.FeeComponentList[j].IsActive == false && (this.FeeComponentList[j].TotalAmount - this.FeeComponentList[j].DiscountAmount - this.FeeComponentList[j].PaidAmount > 0)) {
                    nflag = true;

                    break;
                }
            }
        }

        if (!pflag) {
            item.IsActive = false;

        }
        else if (pflag && nflag || index == this.FeeComponentList.length - 1) {
            item.IsActive = item.IsActive;

        }
        else
            item.IsActive = true;
    }
    this.GetDueAmount(item, index);
}
HidePay = false;
GetTotalPayableAmount  (item, index) {
    this.ReceiptNo = '';
    this.HidePay = false;
    this.ChkSelectInstallment(item, index);
    var TotalPayableAmount = 0;
    var TotalDiscountAmount = 0;
    var TransportAmount = 0;

    for (var i = 0; i < this.FeeComponentList.length; i++) {

        if (this.FeeComponentList[i].IsActive) {
            
            TotalPayableAmount = TotalPayableAmount + (this.FeeComponentList[i].TotalAmount - this.FeeComponentList[i].DiscountAmount - this.FeeComponentList[i].PaidAmount);
            TotalDiscountAmount = TotalDiscountAmount + this.FeeComponentList[i].DiscountAmount;
          
            for (var j = 0; j < this.FeeComponentList[i].ComponentList.length; j++) {
                if (this.FeeComponentList[i].ComponentList[j].ComponentTypeID == 5) {
                    TransportAmount = TransportAmount + this.FeeComponentList[i].ComponentList[j].Amount - this.FeeComponentList[i].ComponentList[j].WaiverAmount - this.FeeComponentList[i].ComponentList[j].PaidAmount;
                }

            }

        }
       

    }
    this.FeeReceiptModel.TransportAmount = TransportAmount;

    this.FeeReceiptModel.FeeAmount = TotalPayableAmount;
    this.FeeReceiptModel.TotalDiscountAmount = TotalDiscountAmount;

    this.GetTotalPaidAmount();

}
PaymentModeList:any;
GetBankCharges  () {

    var BankCharges = 0;

    for (var i = 0; i < this.PaymentModeList.length; i++) {

        if (this.PaymentModeList[i].ItemCode1 == this.FeeReceiptModel.PaymentMode) {

            BankCharges = this.PaymentModeList[i].BankCharges;
        }

    }
    this.FeeReceiptModel.BankCharges = Math.round(BankCharges);
    this.GetTotalWithCharges();

}
GetTotalWithCharges  () {

    this.FeeReceiptModel.PaidAmount = (this.FeeReceiptModel.PaidAmount) + (this.FeeReceiptModel.BankCharges);


}
GetTotalPaidAmount  () {
    this.FeeReceiptModel.PaidAmount = (this.FeeReceiptModel.FeeAmount) + (this.FeeReceiptModel.Fine)
                          + (this.FeeReceiptModel.OpeningAmount) - (this.FeeReceiptModel.WaiverAmount)
    //+ parseFloat(this.FeeReceiptModel.BankCharges)

    this.FeeReceiptModel.PayingAmount = this.FeeReceiptModel.PaidAmount;
}
GetTotal  (StudentFeeDetailsList) {
    var sum = 0;
    for (var i = 0; i < StudentFeeDetailsList.length; i++) {
        sum = sum + StudentFeeDetailsList[i].TotalPaidAmount;
    }
    this.FeeReceiptModel.TotalAmount = sum;

}

CalculateDue  () {
    this.FeeReceiptModel.DueFee = this.FeeReceiptModel.TotalAmount - this.FeeReceiptModel.PaidAmount;
}
CalculatePayingAmount  () {
    var PayingAmount = this.FeeReceiptModel.PayingAmount - this.FeeReceiptModel.OpeningAmount;
    var PartialRemarks = '';
    if (PayingAmount > 0) {
        PayingAmount = PayingAmount + this.FeeReceiptModel.WaiverAmount - this.FeeReceiptModel.Fine;
        if (PayingAmount > 0) {
            for (var i = 0; i < this.FeeComponentList.length ; i++) {

                if (this.FeeComponentList[i].IsActive == true && PayingAmount > 0) {

                    var start = 0;
                    var DueAmount = 0;
                    for (var j = 0; j < this.FeeComponentList[i].ComponentList.length ; j++) {

                        if ((PayingAmount >= this.FeeComponentList[i].ComponentList[j].DueAmount) && this.FeeComponentList[i].ComponentList[j].DueAmount != 0) {

                            this.FeeComponentList[i].ComponentList[j].Paid = this.FeeComponentList[i].ComponentList[j].DueAmount;

                            DueAmount = DueAmount + this.FeeComponentList[i].ComponentList[j].DueAmount;
                            if (this.FeeComponentList[i].ComponentList[j].Paid == 0) {
                                this.FeeComponentList[i].ComponentList[j].WaiverAmount = 0;
                            }
                            else {
                                this.FeeComponentList[i].ComponentList[j].WaiverAmount = (this.FeeComponentList[i].ComponentList[j].WaiverAmount / ((this.FeeComponentList[i].ComponentList[j].Amount+this.FeeComponentList[i].ComponentList[j].WaiverAmount) == this.FeeComponentList[i].ComponentList[j].WaiverAmount ? 1 : (this.FeeComponentList[i].ComponentList[j].Amount ))) * this.FeeComponentList[i].ComponentList[j].Paid;
                            }
                        }
                        else if (this.FeeComponentList[i].ComponentList[j].DueAmount > PayingAmount) {
                            this.FeeComponentList[i].ComponentList[j].Paid = PayingAmount;
                            DueAmount = DueAmount + PayingAmount;
                            if (this.FeeComponentList[i].ComponentList[j].Paid > 0) {
                                this.FeeComponentList[i].ComponentList[j].WaiverAmount = (this.FeeComponentList[i].ComponentList[j].WaiverAmount / ((this.FeeComponentList[i].ComponentList[j].Amount+this.FeeComponentList[i].ComponentList[j].WaiverAmount) == this.FeeComponentList[i].ComponentList[j].WaiverAmount ? 1 : (this.FeeComponentList[i].ComponentList[j].Amount ))) * this.FeeComponentList[i].ComponentList[j].Paid;
                            }
                            else {
                                this.FeeComponentList[i].ComponentList[j].WaiverAmount = 0;
                            }
                            PayingAmount = 0;
                        }

                        PayingAmount = PayingAmount - this.FeeComponentList[i].ComponentList[j].DueAmount;
                    }

                    if (this.FeeComponentList[i].TotalAmount - this.FeeComponentList[i].DiscountAmount == DueAmount) {
                        if (PartialRemarks.length == 0)
                            PartialRemarks = PartialRemarks + this.FeeComponentList[i].Installment
                        else
                            PartialRemarks = PartialRemarks + ',' + this.FeeComponentList[i].Installment
                    }
                    else {
                        if (PartialRemarks.length == 0)
                            PartialRemarks = PartialRemarks + this.FeeComponentList[i].Installment + '(Partial)'
                        else
                            PartialRemarks = PartialRemarks + ',' + this.FeeComponentList[i].Installment + '(Partial)'
                    }
                }
            }
            this.FeeReceiptModel.PartialRemarks = PartialRemarks;

            return true;
        }
        else {
            this.PayingFineAlert = 'Paying Amount must be greater than fine amount excluding previous due';
            return false;
        }

    }
    return true;
}
PayingFineAlert="";
loadingpay = false;
FineAlert = '';
PaymentAlert = '';
AmountAlert = '';
SaveStudentFeePaymentNew  () {
    this.FineAlert = '';

    if (this.FeeReceiptModel.PaymentMode == '' || this.FeeReceiptModel.PaymentMode == undefined) {

        this.PaymentAlert = 'Please Select Payment Mode';
        return;

    }

    //else if (this.FeeReceiptModel.PayingAmount <= (parseFloat(this.FeeReceiptModel.OpeningAmount) + parseFloat(this.FeeReceiptModel.Fine) - parseFloat(this.FeeReceiptModel.WaiverAmount))) {
    //    this.PayingFineAlert = 'Paying Amount Can’t Less, Please pay some extra than dues and fine';
    //    return;
    //}

    if (this.CalculatePayingAmount()) {

        //if (this.ValidAmount()) {
        if (this.FeeReceiptModel.OpeningAmount < this.FeeReceiptModel.PayingAmount) {
            this.FeeReceiptModel.OpeningAmount = this.FeeReceiptModel.OpeningAmount;
        }
        else {
            this.FeeReceiptModel.OpeningAmount = this.FeeReceiptModel.PayingAmount;
        }
        if (this.FeeReceiptModel.PaidAmount > 0) {


            this.HidePay = true;

            this.loadingpay = true;

            
            this.financeService.SaveStudentFeePaymentNew(JSON.stringify(this.FeeReceiptModel), JSON.stringify(this.FeeComponentList)).subscribe((response: any) => {
                this.globalHelper.CheckActionStatus(response);
                
                    this.loadingpay = false;
              
                if (response.webResponse.Status) {
                    this.AmountAlert = '';
                    this.PayingFineAlert = '';
                    this.FeeReceiptModel.PartialRemarks = '';
                    // this.ClearFeeDetails();
                    this.ReceiptNo = response.ReceiptNo;
                    this.GetPaymentReceipt();
                    this.GetFeeInstallmentComponent();
                   
                    this.GetOpeningBalance();

                }

            });
        }
    }


}
PaymentModel={
    PGOrderNo:"",
    OrderNo:"",
    PaidAmount:0,
    CreditAmount:0,
    CurrencyCode:"",
    Key:"",
    Email:"",
    Mobile:'',
    CustomerName:"",
    CustomerID:0,
    RefernceNo:"",
    Signature:"",
    ReceiptNo:"",
    CurrencyRate:"",
    
  };
ProceedtoPayment  () {
    this.FineAlert = '';
this.IsShow=false;
    if (this.FeeReceiptModel.PaymentMode == '' || this.FeeReceiptModel.PaymentMode == undefined) {

        this.PaymentAlert = 'Please Select Payment Mode';
        return;

    }

    //else if (this.FeeReceiptModel.PayingAmount <= (parseFloat(this.FeeReceiptModel.OpeningAmount) + parseFloat(this.FeeReceiptModel.Fine) - parseFloat(this.FeeReceiptModel.WaiverAmount))) {
    //    this.PayingFineAlert = 'Paying Amount Can’t Less, Please pay some extra than dues and fine';
    //    return;
    //}

    if (this.CalculatePayingAmount()) {

        //if (this.ValidAmount()) {
        if (this.FeeReceiptModel.OpeningAmount < this.FeeReceiptModel.PayingAmount) {
            this.FeeReceiptModel.OpeningAmount = this.FeeReceiptModel.OpeningAmount;
        }
        else {
            this.FeeReceiptModel.OpeningAmount = this.FeeReceiptModel.PayingAmount;
        }
        if (this.FeeReceiptModel.PaidAmount > 0) {


            this.HidePay = true;

            this.loadingpay = true;

          
            this.financeService.CreateRazorOrderStudentFee(JSON.stringify(this.FeeReceiptModel), JSON.stringify(this.FeeComponentList)).subscribe((response: any) => {
                this.globalHelper.CheckActionStatus(response);
                
                    this.loadingpay = false;
          
                if (response.webResponse.Status) {
                    // this.AmountAlert = '';
                    // this.PayingFineAlert = '';
                    // this.FeeReceiptModel.PartialRemarks = '';
                    // // this.ClearFeeDetails();
                    // this.ReceiptNo = response.ReceiptNo;
                    // this.GetPaymentReceipt();
                    // this.GetFeeInstallmentComponent();
                   
                    // this.GetOpeningBalance();
                    this.PaymentModel.PGOrderNo=response.PGOrderNo;
                    this.PaymentModel.PaidAmount=this.FeeReceiptModel.PaidAmount;                    
                    this.PaymentModel.OrderNo=response.OnlineReceiptID;   
                    this.PaymentModel.CurrencyCode="INR";  
                    this.PaymentModel.CurrencyRate="1";  
                    this.PaymentModel.CustomerName=this.FeeReceiptModel.StudentName;  
                    this.PaymentModel.Mobile=this.FeeReceiptModel.Mobile;  
                    this.PaymentModel.Email=this.FeeReceiptModel.EmailID;  
                    this.payWithRazor();
                   
                }

            });
        }
    }


}
payWithRazor() {
   
    const options: any = {
    key: this.PaymentModel.Key,
    amount: this.PaymentModel.PaidAmount*100, // amount should be in paise format to display Rs 1255 without decimal point
    currency: this.PaymentModel.CurrencyCode,
    name: this.globalHelper.GetLoginToken().BranchName, // company name or product name
    description: 'Student Fee',  // product description
    image: this.globalHelper.ApiUrl+"Common/Logo/"+this.globalHelper.GetLoginToken().SchoolLogoPath, // company logo or product image
    order_id: this.PaymentModel.PGOrderNo, // order_id created by you in backend      
    merchant_order_id: this.PaymentModel.OrderNo,
    prefill: {
      email: this.PaymentModel.Email,
      contact:this.PaymentModel.Mobile,
      name: this.PaymentModel.CustomerName
     
    },
    modal: {
      // We should prevent closing of the form when esc key is pressed.
      escape: false,
    },
    notes: {
      //include notes if any
      Branch: this.globalHelper.GetLoginToken().BranchName,
      StudentNo:this.FeeReceiptModel.StudentNo,
      Name: this.PaymentModel.CustomerName,
      class: this.FeeReceiptModel.ClassName
    },
    theme: {
      color: '#0c238a'
    }
  };
  options.handler = ((response, error) => {
    options.response = response;
         this.PaymentModel.RefernceNo=options.response .razorpay_payment_id;  
        this.PaymentModel.Signature=options.response .razorpay_signature;            
         
        this.VerifyRazorOrderPayment(options.response )

  
      
  });
  options.modal.ondismiss = (() => {
    // handle the case when user closes the form while transaction is in progress
    console.log('Transaction cancelled.');
  });
  const rzp = new this.winRef.nativeWindow.Razorpay(options);
  rzp.open();

 
}
responseData:any;
VerifyRazorOrderPayment(item){
 
    this.financeService.VerifyRazorOrderPayment(JSON.stringify(this.PaymentModel)).subscribe((data) => {
      this.responseData = data;
      
           if(this.responseData.webResponse.Status){
            
             this.PaymentModel.ReceiptNo=this.responseData.ReceiptNo;  
                  
             this.globalHelper.CheckActionStatus(data);
             if(this.PaymentModel.PaidAmount>0){
             window.localStorage.setItem("razorpay_payment_id", item.razorpay_payment_id);
             window.localStorage.setItem("razorpay_signature", item .razorpay_signature);
             window.localStorage.setItem("razorpay_order_id", item.razorpay_order_id);
             
           }
           else{
            this.IsShow=true;
           }
             window.localStorage.setItem("ReceiptNo", this.PaymentModel.ReceiptNo);
             window.localStorage.setItem("ReceiptNo1", this.PaymentModel.ReceiptNo);
              window.location.reload();
            
    
     }
     else{
     alert("Your request is not processed successfully. Please try again after clicking Pay button.");
     }
      
    
    });
    
    }
IsConcession = true;
GetFeeInstallmentComponent  () {
    this.IsConcession = true;
    this.studentPortalService.GetFeeInstallmentComponent_StudentPortal(this.FeeReceiptModel.ClassID, this.FeeReceiptModel.StudentID).subscribe((response: any) => {
        if (response.webResponse.Status) {
            this.FeeComponentList = response.FeeComponentList;
            this.ComponentList = response.ComponentList;
            this.isCollapsed1 = false;
            var TotalPaidAmount = 0;
            var TotalPayableAmount = 0;
            var TotalDueAmount = 0;
            for (var i = 0; i < this.FeeComponentList.length; i++) {
                TotalPayableAmount = TotalPayableAmount + (this.FeeComponentList[i].TotalAmount - this.FeeComponentList[i].DiscountAmount);
                TotalPaidAmount = TotalPaidAmount + this.FeeComponentList[i].PaidAmount;
                TotalDueAmount = TotalDueAmount + (TotalPayableAmount - TotalPaidAmount);
            }
            this.TotalPayableAmount = Math.round(TotalPayableAmount);
            this.TotalPaidAmount = Math.round(TotalPaidAmount);
            this.TotalDueAmount = Math.round(TotalDueAmount);
        }
    });
};

GetReceipt()
{
    
 return window.localStorage.getItem("ReceiptNo1")==null?'': window.localStorage.getItem("ReceiptNo1");
}
TotalPayableAmount=0;
TotalPaidAmount =0;
 TotalDueAmount = 0;

 GetFee(){

return JSON.stringify(this.FeeComponentList);
 }

 GetBasic(){

    return JSON.stringify(this.FeeReceiptModel)

 }
 IsShow=true;
  ngOnInit() {
   
    if(this.GetReceipt()==null)
    {
       
    
      this.router.navigate(['studentfeepayment'])
    }
    else if(this.GetReceipt()=='') {
        
        this.router.navigate(['studentfeepayment'])
      
    }
    else if(this.GetReceipt()!=null && this.GetReceipt()!='') {
        this.router.navigate(['paymentsuccess']);
    }
    this.GetStudentDetails();
     window.localStorage.setItem("ReceiptNo1", '');
  }

  onPost(): void {
    this.posting = true;
    
  }

  onReset(event): void {
    this.posting = false;
  }

  ngAfterViewChecked() {      
    if (this.posting && this.myFormFeePayment) {
        this.myFormFeePayment.nativeElement.submit();
    }
  }
}
